import React, { Component } from "react";
// import ReactGA from "react-ga4";
import hoistNonReactStatic from "hoist-non-react-statics";

// const __ga_code = process.env.REACT_APP_GOOGLE_ANALYTICS_CODE;
// const __ga_code = REACT_APP_GOOGLE_ANALYTICS_CODE;

export default function withTracker(WrappedComponent, options = {}) {
	const trackPage = page => {
		return;
		// // If the analytics code is not available, don't try to track anything
		// if (!__ga_code || __ga_code === "") return;

		// ReactGA.send({ hitType: 'pageview', page: page });

		// // ReactGA.set({ page, ...options });
		// // // console.log(page);
		// // ReactGA.pageview(page);
	};

	const HOC = class extends Component {
		componentDidMount() {
			const page = this.props.location.pathname;
			trackPage(page);
		}

		componentWillReceiveProps(nextProps) {
			const currentPage = this.props.location.pathname;
			const nextPage = nextProps.location.pathname;

			if (currentPage !== nextPage) {
				trackPage(nextPage);
			}
		}

		render() {
			return <WrappedComponent {...this.props} />;
		}
	};

	hoistNonReactStatic(HOC, WrappedComponent);

	return HOC;
}



// WEBPACK FOOTER //
// ./src/components/GARouteWrapper.js